import React from "react";
import CarouselContainer from "../../../Components/BonusUi/Carousel";

export default function Carousel() {
  return (
    <div className="page-body">
      <CarouselContainer />
    </div>
  );
}
